class VueDependencyError extends Error {
  constructor(message, dependencyName, error) {
    super(error)
    this.name = 'VueDependencyError'
    this.dependencyName = dependencyName
    this.message = `${this.name}, [${this.dependencyName}]: ${message}: ${error}`
  }
}
export default VueDependencyError
